App.load('bower::wicket/wicket-leaflet')
jsts = App.load('bower::jsts/lib/jsts')
StringUtil = App.load('core::utils/string')


L.GeoUtil = L.Class.extend
    statics:

        # rotates lat lng array around lat/lng center
        rotatePoints: (center, angle, points) ->
            angle = angle * (Math.PI / 180) # Convert to radians
            console.log points
            for point in points
                rotatedX = Math.cos(angle) *
                    (point.lng - center.lng) - Math.sin(angle) *
                    (point.lat - center.lat) + center.lng
                rotatedY = Math.sin(angle) *
                    (point.lng - center.lng) + Math.cos(angle) *
                    (point.lat - center.lat) + center.lat

                point.lng = rotatedX
                point.lat = rotatedY




        unnestAdd: (featuregroup, geom) ->
            if(geom instanceof L.LayerGroup)
                geom.eachLayer (ll) =>
                    L.GeoUtil.unnestAdd featuregroup, ll
            else
                featuregroup.addLayer geom

        # converts a feature collection of Polygons / MultiPolygons
        # into a single multipolygon. This is sadly required for
        # doing polygon clipping (it only works feature + feature),
        # not collection + collection
        multiPolygonize: (fc) =>
            addPoly = (dest, ft) =>
                if ft.geometry?.type is 'Polygon'
                    dest.geometry.coordinates.push ft.geometry.coordinates
                else if ft.geometry?.type is 'MultiPolygon'
                    for poly in ft.geometry.coordinates
                        dest.geometry.coordinates.push poly

            multi =
                'type': 'Feature'
                'properties': {}
                'geometry':
                    'type': 'MultiPolygon'
                    'coordinates': []

            if fc.type is 'FeatureCollection'
                for ft in fc.features
                    addPoly(multi, ft)
            else
                addPoly(multi, fc)

            return multi


        # Combine 2 geometries using the specified JSTS geometry.
        # This method will *not* alter existing geometries to be
        # their cropped counterparts; it simply does the operation
        # on a JSTS copy of the geometries, and returns a new
        # JSTS geometry representing the result of the operation
        combine: (geom1, geom2, operation, extra_args = []) ->
            if not operation
                throw new TypeError 'A combine operation must be specified'

            geom1_j = L.GeoUtil.readToJSTS geom1
            geom2_j = L.GeoUtil.readToJSTS geom2

            if not geom1_j[operation]?
                throw new ReferenceError "#{operation} is not a valid JSTS operation"

            args = [geom2_j].concat extra_args

            try
                result = geom1_j[operation].apply(geom1_j, args)
            catch e
                console.log(e)
                return geom1_j
            return result


        # Prune ugly bad nasty points.
        prune: (geom) ->
            if geom instanceof L.FeatureGroup
                geom.eachLayer (l) ->
                    L.GeoUtil.prune l


            else if geom._latlngs? and geom._latlngs.length > 3
                pts_remove = []
                for i, j in geom._latlngs
                    pt1 = new jsts.geom.Coordinate(i.lng, i.lat)

                    ll2 = geom._latlngs[j + 1]
                    ll3 = geom._latlngs[j + 2]

                    if not ll2?
                        ll2 = geom._latlngs[0]
                        ll3 = geom._latlngs[1]
                    else if not ll3?
                        ll3 = geom._latlngs[0]

                    pt2 = new jsts.geom.Coordinate(ll2.lng, ll2.lat)
                    pt3 = new jsts.geom.Coordinate(ll3.lng, ll3.lat)

                    angle = jsts.algorithm.Angle.angleBetween(pt1, pt2, pt3)

                    if (angle * L.LatLng.RAD_TO_DEG) < 2
                        pts_remove.push ll2


                for i in pts_remove
                    ind = geom._latlngs.indexOf(i)
                    if ind isnt -1
                        geom._latlngs.splice(ind, 1)

                geom.redraw()


        prune2: (geom) ->
            gg = L.GeoUtil.readToJSTS(geom)

            geom = L.GeoUtil._cleanJstsPolygon(gg)

            return geom



        _cleanJstsPolygon: (poly) ->
            if not poly.isValid()
                if poly instanceof jsts.geom.Polygon
                    ngeom = new jsts.geom.Polygon(poly.shell)

                    for i in poly.holes
                        ngeom = L.GeoUtil.combine(
                            ngeom
                            new jsts.geom.Polygon(i),
                            'difference'
                        )

                    return ngeom
                else if poly instanceof jsts.geom.MultiPolygon
                    ngeom = new jsts.geom.MultiPolygon([])
                    for i in poly.geometries
                        ngeom.geometries.push(L.GeoUtil._cleanJstsPolygon(i))

                    return ngeom

            else
                return poly

        ###
        tris: (geom) ->
            gg = L.GeoUtil.readToJSTS(geom)

            tr = new jsts.triangulate.DelaunayTriangulationBuilder()
            tr.setSitesFromGeometry(gg)

            return tr.getTriangles(gg.getFactory())
        ###

        dedupPoints: (geom) ->
            if geom instanceof L.FeatureGroup
                geom.eachLayer (l) ->
                    L.GeoUtil.dedupPoints l

            else if geom._latlngs?
                array = geom._latlngs.slice(0)

                #array.sort();
                for i, ind in array
                    continue if ind is 0

                    if (array[ind - 1].toString() is array[ind].toString())

                        geom._latlngs.splice(geom._latlngs.indexOf(i), 1)



        # Copies a geometry safely by converting to WKT and then back
        # to geometry. This isn't perfect, because the Wicket library
        # seems to try and clean up / optimize geometries, so you will
        # potentially not get the exact same type of geometry back
        # that you passed in. I don't *think* it will actually happen
        # or be a problem... but you've been warned.
        #
        # NOTE: it's usually better to use the geometry's cloneGeom() method.
        # For example:
        #
        #   p = new L.Polygon([...]);
        #   copy = p.cloneGeom()
        #
        copyGeometry: (geom) ->
            wkt = new Wkt.Wkt()
            w = wkt.fromObject(geom)

            return wkt.toObject(w)


        # A different method (testing) of copying geometries. It preserves
        # all properties
        cloneGeometry: (geom) ->
            return $.extend true, {}, geom


        # Reads a leaflet layer into a jsts geometry
        # by converting to WKT (through the Wicket lib)
        # and reading the WKT into jsts
        #
        # returns: jsts.geom.Geometry
        readToJSTS: (feature) ->
            if feature.CLASS_NAME? and
            (typeof feature.CLASS_NAME is 'string') and
            StringUtil.startsWith(feature.CLASS_NAME, 'jsts')
                return feature

            if feature.getLayers?
                group = L.featureGroup()
                L.GeoUtil.unnestAdd group, feature
                feature = group

            wkt = new Wkt.Wkt()
            w   = wkt.fromObject(feature)

            reader = new jsts.io.WKTReader()

            return reader.read(w.write())


        # Reads a JSTS object back into leaflet geojson object
        # by writing the JSTS geometry out to geojson and reading
        # that geojson into an L.GeoJSON
        #
        # returns: Leaflet Feature/Layer (L.FeatureGroup, usually)
        readFromJSTS: (geometry, options = {}) ->
            if geometry.CLASS_NAME? and StringUtil.startsWith(geometry.CLASS_NAME, 'jsts')

                writer = new jsts.io.GeoJSONWriter()

                return new L.GeoJSON(writer.write(geometry), options)

            return geometry




        # Stupid bug in JSTS means that buffer on multiploygon
        # fails sometimes, so descend into the multipolygon and buffer each poly individually
        #
        safeBuffer: (geom, bufferfactor) ->
            geom = L.GeoUtil.readToJSTS(geom)

            if geom instanceof jsts.geom.MultiPolygon
                if geom.geometries?
                    for i in geom.geometries
                        i = i.buffer(bufferfactor)
            else
                geom = geom.buffer(bufferfactor)

            return geom


        # Method for setting a style on all children of a layer group
        # (includes multiple nested layer/featuregroups)
        setNestedStyles: (fg, style) ->
            if $.isFunction style
                style = style(fg)

            fg.eachLayer (l) ->
                if l instanceof L.LayerGroup
                    L.GeoUtil.setNestedStyles l, style
                else if l.setStyle?
                    if $.isFunction style
                        newstyle = style(l)
                    else
                        newstyle = style

                    l.setStyle newstyle


        # Calculates the acreage of a leaflet layer.
        #
        # If it's a feature group, we return an array of
        # the acreages of the child layers. This may not be
        # ideal, but it works for now and (currently) that behavior
        # is not triggered anywhere.
        #
        # The method of calculation is kind of interesting
        getAcreage: (poly) ->
            #ensure it's a leaflet geometry
            poly = L.GeoUtil.readFromJSTS(poly)

            if poly instanceof L.FeatureGroup
                acreages = []

                poly.eachLayer (l) ->
                    acreages.push L.GeoUtil.getAcreage(l)

                return acreages


            south   = poly.getBounds().getSouth()
            east    = poly.getBounds().getEast()

            if not poly.cloneGeom?
                return
            # Convert the object so we aren't screwing up the original object
            poly = poly.cloneGeom()#L.GeoUtil.copyGeometry poly

            # convert points to be in terms of METERS from the southeast corner.
            poly.eachPoint (index, point) ->
                lat = point.distanceTo [south, point.lng]
                lng = point.distanceTo [point.lat, east]

                point.lat = lat
                point.lng = lng


            geom = L.GeoUtil.readToJSTS(poly)

            # Convert from Square Meters to acres
            if not App.is_metric
                return geom.getArea() * 0.000247105
            # Convert from Square Meters to hectares
            else
                return geom.getArea() * 0.0001


        # like getAcreage, but returns a sum if the geometry
        # is a layer group, instead of an array of individual areas
        getSumAcreage: (group) ->

            sum = (acc, x) ->
                if $.isArray x
                    for i in x
                        acc += sum(0, i)

                else
                    acc += parseFloat(x)

                return acc

            acres = L.GeoUtil.getAcreage(group)

            if $.isArray acres
                acres = List.foldl sum, 0, acres

            return acres




        getHoleAcreage: (poly, hole_id) ->
            ll = poly._holes[hole_id]

            return L.GeoUtil.getAcreage(new L.Polygon(ll))
